module.exports = __webpack_public_path__ + "files/621b4450488c2a1c79703f9f5c5d397c.png";